// extracted by mini-css-extract-plugin
module.exports = {"table":"table-2228b5002d74eb35f082ff62c853552d","table__title":"table__title-178c1ebc5b3994dda9998791a2823805","upload":"upload-0f066535efdf55afce1d36a590d7f9ba"};